'use strict';

/**
 * @function handleReviewRating
 * @description
 * Handles click events on Bazaarvoice rating/review stars and sub-containers.
 * - Scrolls to the reviews section or triggers review tab if needed.
 * - Handles navigation for compare product ratings.
 */
const handleReviewRating = function () {
    // Handle click on review rating stars or summary chevron in product compare
    $('#product-compare').on('click', '.bv_sub_container, .bv_stars_component_container', function (e) {
        const $ratingContainer = $(this).closest('.product-compare-rating');
        if ($ratingContainer.length) {
            e.preventDefault();
            handleReviewRatingClick($(this));
        }
    });

    // Function to handle click on review rating stars or summary chevron
    // This function checks if the clicked element is part of a product compare rating section
    function handleReviewRatingClick($element) {
        const $parentLi = $element.closest("li");
        const liIndex = $parentLi.index() + 1;
        const $ratingContainer = $element.closest('.product-compare-rating');

        if ($ratingContainer.length) {
            if (liIndex === 1 && !$('.compare-rating-updated').length) {
                const $reviews = $("#reviews");
                if ($reviews.length) {
                    $('html, body').stop(true, true).animate({
                        scrollTop: $reviews.offset().top - 100
                    }, 1000);
                }
            } else {
                // Find the closest .bv_main_container with an href
                const $mainContainer = $element.closest(".bv_main_container[href]");
                if ($mainContainer.length) {
                    window.location.href = $mainContainer.attr("href");
                }
            }
        }
    }
}


/**
 * @function init
 * @description Initializes rating and review scroll logic for product compare.
 */
export default {
    init: function () {
        handleReviewRating();
    }
};